import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import MeetingService from '../../../api/services/MeetingService';
import { RootState } from '../../../store';
import { generateBoilerplateAsyncThunkMatchers } from '../../../store/helpers';

const ACTIONS_PREFIX = 'meeting';

type VisitFeatureProps = {
  meeting: any;
  isLoading: boolean;
  error?: string;
};

const initialState: VisitFeatureProps = {
  meeting: {},
  isLoading: false,
};

export const getZoomCallSignature = createAsyncThunk(
  `${ACTIONS_PREFIX}/getZoomCallSignature`,
  MeetingService.getZoomCallSignature,
);

const meetingSlice = createSlice({
  name: 'meeting',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getZoomCallSignature.fulfilled, (state, action) => {
      state.meeting = action.payload.resource;
    });
    generateBoilerplateAsyncThunkMatchers<VisitFeatureProps>(builder, ACTIONS_PREFIX);
  },
});

export const meetingState = (state: RootState) => state.meeting;
export default meetingSlice.reducer;
